import axios from 'axios';
import { config } from '../../Configs';

export const GetContractContributionExemptionAPI = async (
  contractId,
  token = null
) => {
  try {
    const configObj = {
      headers: {
        Authorization: token
      }
    };

    const response = await axios.get(
      `${config.api.url}/contracts/industrials/exemptions/${contractId}`,
      configObj
    );

    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GetIndustrialContractDocumentsAPI = async (
  contractId,
  authToken,
  month,
  year
) => {
  try {
    const configObj = {
      params: { month, year },
      headers: { Authorization: authToken }
    };

    const response = await axios.get(
      `${config.api.url}/contracts/industrials/documents/${contractId}`,
      configObj
    );

    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GetIndustrialContractVolumesAPI = async (
  contractId,
  authToken,
  month,
  year
) => {
  try {
    const configObj = {
      params: { month, year },
      headers: { Authorization: authToken }
    };

    const response = await axios.get(
      `${config.api.url}/contracts/industrials/volumes/${contractId}`,
      configObj
    );

    return { success: true, data: response.data.data };
  } catch (err) {
    return { success: false, error: err };
  }
};
